export default "__VITE_ASSET__Dp1sZgPW__"